var map = {
	"./1924.svg": "d036",
	"./1929.svg": "7300",
	"./1935.svg": "0416",
	"./1950.svg": "dae8",
	"./1958.svg": "223f",
	"./1958_.svg": "2f71",
	"./1958_horizontal.svg": "9136",
	"./1961.svg": "33a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df25";